<template>
  <div>
    <form-field-input
      label="Name"
      v-model="form.label"
      v-autofocus
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>

    <form-field-select-status
      label="Default Status"
      v-model="form.default_status_id"
      :validation-errors="validationErrors.default_status_id"
      include-no-status
    ></form-field-select-status>

    <form-field-select-user-emails
      label="Email From"
      v-model="form.user_id"
      :validation-errors="validationErrors.user_id"
    ></form-field-select-user-emails>

    <form-field-input
      label="Email From Name"
      v-model="form.from_name"
      :validation-errors="validationErrors.from_name"
    ></form-field-input>

    <form-field-switch
        label="Use Campaign Number"
        v-model="form.use_records_campaign_number"
        :validation-errors="validationErrors.use_records_campaign_number"
        description="SMS sent for this sequence will use each lead's campaign phone number. If no campaign the Default SMS From Number will be used."
    ></form-field-switch>

    <form-field-select-integration-phone-number
        v-model="form.integration_phone_number_id"
        :validation-errors="validationErrors.integration_phone_number_id"
    ></form-field-select-integration-phone-number>

    <form-field-select
      label="When Sequence Complete"
      v-model="form.end_step_option"
      :validation-errors="validationErrors.end_step_option"
    >
      <option
          v-for="option in ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum"
          :value="option.value"
      >{{ option.label }}</option>
    </form-field-select>

    <form-field-select
      v-show="form.end_step_option === ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum.StartNewSequence.value"
      label="New Sequence"
      v-model="form.end_step_fus_template_id"
      :validation-errors="validationErrors.end_step_fus_template_id"
    >
      <option
        v-for="option in $store.getters.fusTemplates"
        :value="option.id"
      >{{ option.label }}</option>
    </form-field-select>

    <form-field-select-status
      v-show="form.end_step_option === ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum.ChangeStatus.value"
      label="Move to Status"
      v-model="form.end_step_status_id"
      :validation-errors="validationErrors.end_step_status_id"
    ></form-field-select-status>

    <p v-if="showNextContactMessage" class="status_note">NOTE: When entering this status the next contact at will be set to 24 hours in the future.</p>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";

export default {
  name: "FollowUpTemplateForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      isSaving: false,
      defaultForm: {
        id: null,
        market_id: this.$store.getters.market.id,
        user_id: null,
        label: '',
        description: '',
        from_name: '',
        integration_phone_number_id: null,
        default_status_id: null,
        use_records_campaign_number: 0,
        end_step_option: ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum.ChangeStatus.value,
        end_step_fus_template_id: null,
        end_step_status_id: null,
      },
    }
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    this.form.user_id = this.activeUserId;
  },
  watch: {
    /**
     * this ensures that end step status or FUS template id is null
     * to avoid issue on deleting FUS if this FUS was used by other FUS and updated to not used it anymore
     */
    'form.end_step_option'(newValue, oldValue) {
      if (newValue === ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum.MoveToManualFollowUp.value) {
        this.form.end_step_status_id = null
        this.form.end_step_fus_template_id = null
      }

      if (newValue === ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum.StartNewSequence.value) {
        this.form.end_step_status_id = null
      }

      if (newValue === ENUMS.FollowUpSequenceTemplateEndStepOptionsEnum.ChangeStatus.value) {
        this.form.end_step_fus_template_id = null
      }
    },
  },
  computed: {
    allStatuses() {
      return this.$store.getters["pipeline/statuses"];
    },
    activeUserId() {
      if (this.$store.getters.activeUsers.find(u => u.id === this.form.user_id)) {
        return this.form.user_id;
      }

      return null;
    },
    showNextContactMessage() {
      if (this.form.end_step_status_id) {
        const state = this.getStateFromStatusId(this.form.end_step_status_id);

        return state === ENUMS.StatusStateEnum.Contacting.value || state === ENUMS.StatusStateEnum.FollowUp.value;
      }

      return false;
    }
  },
  methods: {
    getStateFromStatusId(statusId) {
      const status = this.allStatuses.find(status => status.id === statusId);

      if (status) return status.state;
    },
    update() {
      return this.$api.fusTemplates.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Follow up template was updated',
            type: 'is-success'
          });

            return res;
          });
    },
    create() {
      return this.$api.fusTemplates.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Follow up template was created',
            type: 'is-success'
          });

            return res;
          });
    },
    delete() {
      return this.$api.fusTemplates.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Follow up template was archived',
            type: 'is-success'
          });

            return res;
          });
    },
  },
}
</script>

<style lang="scss" scoped>

.status_note {
  font-size: 0.75rem;
  line-height: 1.3;
}
</style>
